"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _BackendIssue = _interopRequireDefault(require("../model/BackendIssue"));

var _Forbidden = _interopRequireDefault(require("../model/Forbidden"));

var _InternalServerError = _interopRequireDefault(require("../model/InternalServerError"));

var _PurchaseOrderPage = _interopRequireDefault(require("../model/PurchaseOrderPage"));

var _Unauthorized = _interopRequireDefault(require("../model/Unauthorized"));

var _ValidationError = _interopRequireDefault(require("../model/ValidationError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* PurchaseOrders service.
* @module api/PurchaseOrdersApi
* @version 0.17
*/
var PurchaseOrdersApi = /*#__PURE__*/function () {
  /**
  * Constructs a new PurchaseOrdersApi. 
  * @alias module:api/PurchaseOrdersApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function PurchaseOrdersApi(apiClient) {
    _classCallCheck(this, PurchaseOrdersApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Retrieve a paginated list of purchase orders which are currently available to a Kitchen Manager or Cook
   * **Scopes**: - `purchase-orders:read` - `schedules:read`  Retrieve a paginated list of purchase orders that are available within a a specified a kitchen's location, or accessible to a user through it's IAM rights. Those purchase orders are in all available states and they are filtered by the IAM rights belonging to the end user.  It's possible to request for upcoming purchase orders which are not generated yet. But we'll only fetch those purchase orders.
   * @param {Object} opts Optional parameters
   * @param {String} opts.locationUuid 
   * @param {Date} opts.startDate 
   * @param {Date} opts.endDate 
   * @param {Boolean} opts.upcoming 
   * @param {Boolean} opts.paginate  (default to true)
   * @param {Number} opts.page  (default to 1)
   * @param {Number} opts.perPage  (default to 20)
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PurchaseOrderPage} and HTTP response
   */


  _createClass(PurchaseOrdersApi, [{
    key: "listPurchaseOrdersWithHttpInfo",
    value: function listPurchaseOrdersWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'location_uuid': opts['locationUuid'],
        'start_date': opts['startDate'],
        'end_date': opts['endDate'],
        'upcoming': opts['upcoming'],
        'paginate': opts['paginate'],
        'page': opts['page'],
        'per_page': opts['perPage']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _PurchaseOrderPage["default"];
      return this.apiClient.callApi('/purchase-orders', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a paginated list of purchase orders which are currently available to a Kitchen Manager or Cook
     * **Scopes**: - `purchase-orders:read` - `schedules:read`  Retrieve a paginated list of purchase orders that are available within a a specified a kitchen's location, or accessible to a user through it's IAM rights. Those purchase orders are in all available states and they are filtered by the IAM rights belonging to the end user.  It's possible to request for upcoming purchase orders which are not generated yet. But we'll only fetch those purchase orders.
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid 
     * @param {Date} opts.startDate 
     * @param {Date} opts.endDate 
     * @param {Boolean} opts.upcoming 
     * @param {Boolean} opts.paginate  (default to true)
     * @param {Number} opts.page  (default to 1)
     * @param {Number} opts.perPage  (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PurchaseOrderPage}
     */

  }, {
    key: "listPurchaseOrders",
    value: function listPurchaseOrders(opts) {
      return this.listPurchaseOrdersWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return PurchaseOrdersApi;
}();

exports["default"] = PurchaseOrdersApi;